export class Pop {

    constructor(target = '.js-pop', options = {}) {
        this.target = target;

        this.options = {
            activeClass: 'js-active',
            closeTrigger: 'js-pop--close',
            closeMain: false,
            scroll: true,
            ...options
        }
    }

    init() {
        this.$triggers = Array.from(document.querySelectorAll(this.target));
        this.$close = Array.from(document.querySelectorAll(`.${this.options.closeTrigger}`));

        this.$triggers.forEach($trigger => {
            let $activates = [];
            const elClone = $trigger.cloneNode(true);
            if (!!$trigger.dataset.activates) {
                const activates = $trigger.dataset.activates.split(',');
                activates.forEach(activate => {
                    if (activate === 'parent') {

                        const parent = $trigger.parentElement;

                        parent.replaceChild(elClone, $trigger);

                        $trigger = parent.querySelector(this.target)

                        $activates.push($trigger.parentElement);
                    } else {
                        $activates.push(document.querySelector(`#${activate}`));
                    }
                })
            } else {
                $activates.push(document.querySelector($trigger.href.replace(/^.*#/, '#')))
            }

            $trigger.addEventListener('click', e => {
                if (e.target.nodeName !== 'A') {
                    let scroll = this.options.scroll;
                    if ($trigger.hasAttribute('data-scroll')) {
                        scroll = ($trigger.dataset.scroll === 'true');
                    }

                    let main = this.options.closeMain;
                    if ($trigger.hasAttribute('data-close-main')) {
                        main = ($trigger.getAttribute('data-close-main') === 'true');
                    }

                    if (main) {
                        const $main = document.querySelector('main');
                        $main.addEventListener('click', () => {
                            const $open = Array.from(document.querySelectorAll(`.${this.options.activeClass}`));

                            $open.forEach($item => {
                                $item.classList.remove(this.options.activeClass);
                            })

                            if (!scroll) {
                                document.documentElement.classList.remove('js-no-scroll');
                            }
                        })
                    }

                    this.$close.forEach($closeTrigger => {

                        $closeTrigger.addEventListener('click', () => {
                            const $open = Array.from(document.querySelectorAll(`.${this.options.activeClass}`));

                            $open.forEach($item => {
                                $item.classList.remove(this.options.activeClass);
                            })

                            if (!scroll) {
                                document.documentElement.classList.remove('js-no-scroll');
                            }
                        })
                    })

                    if ($trigger.hasAttribute('data-toggle')) {

                        if (!$trigger.classList.contains(this.options.activeClass)) {
                            const $active = document.querySelectorAll(`.${this.options.activeClass}`);

                            $active.forEach( $item => {
                                $item.classList.remove(this.options.activeClass)
                            })
                        }

                        $trigger.classList.toggle(this.options.activeClass);

                        $activates.forEach($activate => {
                            $activate.classList.toggle(this.options.activeClass);
                        })
                        if ($trigger.hasAttribute('data-scroll-to')) {
                            $activates[0].parentElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                                inline: 'nearest'
                            })
                        }

                        if (!scroll) {
                            document.documentElement.classList.toggle('js-no-scroll');
                        }
                    } else {
                        $activates.forEach($activate => {
                            $activate.classList.toggle(this.options.activeClass);
                        })

                        if ($trigger.hasAttribute('data-scroll-to')) {
                            $activates[0].parentElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                                inline: 'nearest'
                            })
                        }

                        if (!scroll) {
                            document.documentElement.classList.add('js-no-scroll');
                        }
                    }
                }
            });
        })
    }

}
